import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientHeadSettingsSaveMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { OnboardingProcessStepNameType } from 'api/types/entity';

import {
  parseOnboardingProcessEntity,
  parseOnboardingSettingsSaveParam,
} from '../../helpers';

export const useLegalClientHeadSettingsSave = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientHeadSettingsSaveMutation();

  const error = useError(apolloError);

  const saveSettings = useCallback(
    async (
      legalId: string,
      headId: string,
      currentStepName: OnboardingProcessStepNameType
    ) => {
      const input = parseOnboardingSettingsSaveParam(currentStepName);
      const res = await handle({
        variables: {
          id: legalId,
          headId,
          input,
        },
      });
      return res.data?.legalClientHeadSettingsSave?.process
        ? parseOnboardingProcessEntity(
            res.data?.legalClientHeadSettingsSave?.process
          )
        : undefined;
    },
    [handle]
  );

  return {
    data,
    loading,
    error,
    saveSettings,
  };
};
